import { render, staticRenderFns } from "./DeliverTips.vue?vue&type=template&id=2710407b&scoped=true"
import script from "./DeliverTips.vue?vue&type=script&lang=js"
export * from "./DeliverTips.vue?vue&type=script&lang=js"
import style0 from "./DeliverTips.vue?vue&type=style&index=0&id=2710407b&prod&scoped=true&lang=css"
import style1 from "./DeliverTips.vue?vue&type=style&index=1&id=2710407b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2710407b",
  null
  
)

export default component.exports